import form from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';

form.init('form');
Zipcode.init();